import { useSyncExternalStore } from 'react';
import Icon from '@/components/atoms/Icon';
import useFilesDragNDrop from '@/components/atoms/inputs/FilesInput/useFilesDragNDrop';
import { FeatureFlagKeys } from '@/services/featureFlag';
import featureFlagStore from '@/stores/featureFlagStore';
import { classnames } from '@/libs/utils';

export default function UploadFileButton({ openSessionsDialog }: { openSessionsDialog: () => void }) {
  const featureFlags = useSyncExternalStore(featureFlagStore.subscribe, featureFlagStore.getSnapshot);
  const isCLHomePageEnabled = featureFlags[FeatureFlagKeys.Use_CL_New_HomePage];

  function onAddNewRecording() {
    openSessionsDialog();
  }

  function onFilesUpload(files: File[]) {
    if (files.length) {
      window.openFilePickerOnDialogLoad = true;
      window.filesPickedForUpload = files;
      onAddNewRecording();
    }
  }

  const { isDragging, uploadFiles, handleDragEnter, handleDragOver, handleDragLeave } = useFilesDragNDrop({
    onFilesUpload
  });

  return (
    <div
      className={classnames(
        'group relative aspect-[4/3] w-[23rem] shrink-0 truncate',
        isCLHomePageEnabled ? 'h-[235px] w-[298px]' : ''
      )}
      onClick={onAddNewRecording}
      onDrop={uploadFiles}
      onDragOver={handleDragOver}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      data-testid="import-file-button"
    >
      <div className="group relative flex h-full cursor-pointer items-center justify-center overflow-hidden !rounded-xl border !border-slate-200/80 bg-slate-200/50 transition-colors duration-150 ease-in-out hover:bg-slate-200">
        <div className="relative z-20 flex flex-col items-center">
          <Icon
            name="IconCircleXFilled"
            className="rotate-45 text-slate-400 transition-colors duration-150 ease-in-out group-hover:text-slate-700"
            size={38}
          />
          <div className="mt-1.5 text-sm text-slate-500 transition-colors duration-150 ease-in-out group-hover:text-slate-700">
            Import File
          </div>
        </div>
        {isDragging && (
          <div className="absolute z-30 flex size-full items-center justify-center !rounded-xl bg-deep-orange">
            <span className="text-xl font-medium">Drop it like it‘s hot</span>
          </div>
        )}
      </div>
    </div>
  );
}
